// extracted by mini-css-extract-plugin
export default {"container":"CurrencySelect_container__20oKQ","title":"CurrencySelect_title__w4XwB","button":"CurrencySelect_button__O0lsR"};